angular.module('rjmNg.api').factory("Dimensions", [
  "$resource"
  "phpServiceUrl"
  ($resource, phpServiceUrl) ->
    Dimensions = $resource(phpServiceUrl("/client/:clientId/metric/:metricId/dimension/:columnId/"), {}
        dependents:
          method: 'GET'
          url: phpServiceUrl("/client/:clientId/metric/:metricId/dimension/:columnId/dependents/")
    )

    return Dimensions
  ]
)
